import React from "react"
import ModalWrapper from "./modal/modal-wrapper"
import { useStaticQuery, graphql } from "gatsby"
import { JobSubscriptionQuery } from "../../graphql-types"

interface JobSubscriptionProps extends JobSubscriptionQuery {
  showFilters?: boolean
}

const JobSubscription: React.FC<JobSubscriptionProps> = showFilters => {
  const data = useStaticQuery(graphql`
    query JobSubscription {
      jobSubscription: datoCmsJobSubscription {
        id
        title
        preamble
        buttonText
      }
    }
  `)

  const buttonText = data.jobSubscription.buttonText
  const title = data.jobSubscription.title
  const preamble = data.jobSubscription.preamble
  const showFiltersParameter = showFilters ? "1" : "0"
  const iFrameUrl = `https://cdn.jobylon.com/jobs/company-groups/156/embed/v3/?target=jobylon-jobs-widget&show_filters=${showFiltersParameter}&group_locations=1&page_size=10`

  return (
    <ModalWrapper
      id="stream-available-jobs"
      title={title}
      buttonText={buttonText}
    >
      <h2 className="c-heading--b c-modal__title">{title}</h2>
      <div
        className="c-modal__preamble"
        dangerouslySetInnerHTML={{ __html: preamble }}
      />
      <iframe
        width="100%"
        height="400px"
        src={iFrameUrl}
        frameBorder="0"
      ></iframe>
    </ModalWrapper>
  )
}

export default JobSubscription
